import { HomeFeed } from './HomeFeed';

const Index = () => {
  return <HomeFeed />;
};

export default Index;
